var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tz-banner',{attrs:{"title":_vm.cms.page.title,"description":_vm.cms.page.last_updated,"is-light":true,"has-overlay":false}}),_vm._v(" "),_c('div',{staticClass:"wl-legal"},[_c('section',{staticClass:"sh-wysiwyg"},[_c('tz-markdown',{attrs:{"content":_vm.cms.page.content}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }